import React from 'react'

const Headers = ({word1}) => {
  return (
    <div className='w-full mt-16 mb-6 flex flex-col items-center gap-3 px-6'>
      <h2 className='text-3xl md:text-4xl font-black bg-gradient-to-r from-pink-500 to-cyan-400 bg-clip-text text-transparent tracking-tight'>
        {word1}
      </h2>
      <div className='h-[2px] w-24 rounded-full bg-gradient-to-r from-pink-500 to-cyan-400 shadow-[0_0_10px_rgba(255,45,120,0.5)]' />
    </div>
  )
}

export default Headers
